@if (isOpen) {
  <div #modal
       class="modal fixed inset-0 z-50 flex items-center justify-center"
       id="{{id}}"
       role="dialog"
       aria-labelledby="exampleModalCenterTitle"
       aria-hidden="true"
       (click)="dismissModal(); $event.preventDefault()">

    <!-- Background shadow -->
    <div class="modal-backdrop absolute inset-0 bg-black opacity-70"
         (click)="dismissModal(); $event.preventDefault()"></div>

    <div class="bg-white w-[475px] rounded-lg relative shadow-lg p-7"
         (click)="$event.stopPropagation(); $event.preventDefault();">

      <!-- Close button positioned half inside and half outside -->
      <button *ngIf="showCloseButton"
              type="button"
              class="absolute -top-4 -right-4 rounded-full "
              aria-label="Close"
              (click)="dismissModal()">
        <img width="40" src="assets/icons/ic_close_dark.svg" alt="Close button"/>
      </button>

      <ng-container *ngIf="modalFace">
        <div class="flex justify-center mb-5">
          <!-- Conditional face images -->
          <ng-container *ngIf="modalFace === 'sad'">
            <img class="w-[70px]" src="assets/icons/ic_sad_face.svg" alt="Sad face"/>
          </ng-container>
          <ng-container *ngIf="modalFace === 'happy'">
            <img class="w-[70px]" src="assets/images/img_happy_face.png" alt="Happy face"/>
          </ng-container>
          <ng-container *ngIf="modalFace === 'caution'">
            <img class="w-[70px]" src="assets/icons/ic_exclamation.svg" alt="Caution face"/>
          </ng-container>
        </div>
      </ng-container>

      <div class="text-center">
        <p *ngIf="title" class="text-2xl font-mSemiBold mb-2.5">{{ title }}</p>
        <p *ngIf="subTitle" class="text-sm text-secondaryText mb-2.5">{{ subTitle }}</p>
        <p *ngIf="message" class="text-sm text-tertiaryText mb-5">{{ message }}</p>
      </div>

      <div class="flex justify-center space-x-4">
      <span *ngIf="negativeButtonText">
        <app-button
          id="negativeButton"
          [label]="negativeButtonText"
          [type]="negativeButtonType"
          (clickEvent)="onNegativeButtonClick(); $event.preventDefault();">
        </app-button>
      </span>

        <span>
        <app-button
          id="positiveButton"
          [label]="positiveButtonText"
          [type]="positiveButtonType"
          (clickEvent)="onPositiveButtonClick(); $event.preventDefault();">
        </app-button>
      </span>
      </div>
    </div>
  </div>

}
